import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    height: 30px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, useState, useMemo, useEffect } from 'react';
import styled from 'styled-components';
import { TextField } from '../TextField';
import { Row } from '../Row';
import { Button } from '../Button';
import { noop } from '../helpers';
var ActionWrapper = styled.div(_templateObject());
export function TextFieldWithActions(_a) {
  var _a$initialValue = _a.initialValue,
      initialValue = _a$initialValue === void 0 ? '' : _a$initialValue,
      strings = _a.strings,
      disabled = _a.disabled,
      readOnly = _a.readOnly,
      _a$onChange = _a.onChange,
      onChange = _a$onChange === void 0 ? noop : _a$onChange,
      props = __rest(_a, ["initialValue", "strings", "disabled", "readOnly", "onChange"]);

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var disableAction = disabled || readOnly;
  useEffect(function () {
    setValue(initialValue);
  }, [initialValue]);
  var handleChangeTextField = useCallback(function (_ref) {
    var value = _ref.target.value;
    return setValue(value);
  }, [setValue]);
  var handleClickSave = useCallback(function () {
    return onChange({
      target: {
        value: value || ''
      }
    });
  }, [value, onChange]);
  var actionButtons = useMemo(function () {
    return React.createElement(Row.Container, {
      gap: 14
    }, React.createElement(Row.Item, null, React.createElement(Button, {
      variant: 'text',
      disabled: disableAction,
      onClick: handleClickSave
    }, strings.save)), React.createElement(Row.Item, null, React.createElement(Button, {
      variant: 'text',
      disabled: disableAction,
      onClick: function onClick() {
        return setValue(initialValue);
      }
    }, strings.discard)));
  }, [handleClickSave, setValue, disableAction, initialValue, strings]);
  return React.createElement(TextField, Object.assign({}, props, {
    onChange: handleChangeTextField,
    value: value,
    disabled: disabled,
    readOnly: readOnly,
    multiline: true,
    startAdornment: React.createElement(ActionWrapper, null, initialValue !== value ? actionButtons : null)
  }));
}